/*
 * Copyright © 2018-2023, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

import { ApiPromise } from "../models/ApiPromise";
import { axiosCommon } from "../util/axiosSetup";
import { Void } from "../models/Void";
import Params from "../common/Params";
import { SiteManagerResponse } from "../models/management/SiteManagerResponse";
import { NewSiteManagerRequest } from "../models/management/NewSiteManagerRequest";
import { UpdateSiteManagerRequest } from "../models/management/UpdateSiteManagerRequest";

export default class SiteManagerApi {
  private static baseUrl = Params.clinicServiceBaseURL;

  static getSiteManagers(): ApiPromise<SiteManagerResponse[]> {
    const url = `${this.baseUrl}/site-managers`;
    return axiosCommon.get(url);
  }

  static addSiteManager(
    request: NewSiteManagerRequest
  ): ApiPromise<SiteManagerResponse> {
    const url = `${this.baseUrl}/site-managers`;
    return axiosCommon.post(url, request);
  }

  static updateSiteManager(
    userId: string,
    request: UpdateSiteManagerRequest
  ): ApiPromise<SiteManagerResponse> {
    const url = `${this.baseUrl}/site-managers/${userId}`;
    return axiosCommon.put(url, request);
  }

  static deleteSiteManager(userId: string): ApiPromise<Void> {
    const url = `${this.baseUrl}/site-managers/${userId}`;
    return axiosCommon.delete(url);
  }
}
